import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useInView } from 'react-intersection-observer';
import "../../css/ShowsEventos.css";
import Eventos from '../eventos/Eventos';

const ShowsEventos = ({ theme = 'ltm' }) => {
    const [loaded, setLoaded] = useState({
        img1: false,
        img2: false,
        img3: false,
    });

    const handleImageLoad = (imgKey) => {
        setLoaded((prev) => ({ ...prev, [imgKey]: true }));
    };

    const { ref: tituloRef, inView: tituloInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: imgRef, inView: imgInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: contentRef, inView: contentInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: contentRef2, inView: contentInView2 } = useInView({ threshold: 0.1, triggerOnce: true });

    return (
        <div id="eventos" className={`${theme}-fondo-rojo`}>
            <div className={`${theme}-showseventos-main-div pt-md-3`}>
                <h1
                    ref={tituloRef}
                    className={`${theme}-titulo-showseventos py-4 mx-5 showseventos-transition-element ${tituloInView ? 'showseventos-animate-in-bottom' : ''}`}
                >
                    SHOWS Y EVENTOS
                </h1>

                <Row>
                    <Col className={`px-5 pb-4 pb-md-5 showseventos-transition-element ${imgInView ? 'showseventos-animate-in-left' : ''}`} md={6} ref={imgRef}>
                        <Row className="mb-2 g-2 g-md-3">

                            {/* 
                                <Col xs={6}>
                                    {!loaded.img1 && <Skeleton height="clamp(40vh, 80vh, 80vh)" width="100%" />}
                                    <img
                                        src="https://picsum.photos/1000/1700"
                                        alt="Image 1"
                                        className="img-fluid"
                                        style={{
                                            objectFit: "cover",
                                            height: "100%",
                                            display: loaded.img1 ? "block" : "none",
                                        }}
                                        onLoad={() => handleImageLoad("img1")}
                                    />
                                </Col>
                            
                            
                                <Col xs={6}>
                                
                                    {!loaded.img2 && <Skeleton height="clamp(40vh, 80vh, 80vh)" width="100%" />}
                                    <img
                                        src="https://picsum.photos/1000/1700"
                                        alt="Image 2"
                                        className="img-fluid"
                                        style={{
                                            objectFit: "cover",
                                            height: "100%",
                                            display: loaded.img2 ? "block" : "none",
                                        }}
                                        onLoad={() => handleImageLoad("img2")}
                                    />
                            */}

                            <Col xs={12}>
                                <Eventos />
                            </Col>
                        </Row>
                    </Col>

                    <Col md={6}>
                        <div
                            ref={contentRef}
                            className={`d-none d-md-block showseventos-transition-element ${contentInView ? 'showseventos-animate-in-right' : ''}`}
                        >
                            <div className={`${theme}-showseventos-container`}>
                                <h3 className={`${theme}-showseventos-container-titulo`}>KARAOKE</h3>
                                <h3 className={`${theme}-showseventos-container-subtitulo`}>TODOS LOS LUNES A LAS 22.00 HS</h3>
                            </div>
                            <div className={`${theme}-showseventos-container`}>
                                <h3 className={`${theme}-showseventos-container-titulo`}>SHOW DE LA SEMANA</h3>
                                <h3 className={`${theme}-showseventos-container-subtitulo`}>TODOS LOS JUEVES A LAS 22.00 HS</h3>
                            </div>
                            <div className={`${theme}-showseventos-container`}>
                                <h3 className={`${theme}-showseventos-container-titulo`}>MÚSICA + KARAOKE</h3>
                                <h3 className={`${theme}-showseventos-container-subtitulo`}>VIERNES BIEN ARRIBA! DESDE LAS 23.30 HS</h3>
                            </div>
                        </div>
                    </Col>
                </Row>

                <div
                    ref={contentRef2}
                    className={`d-md-none pb-4 showseventos-transition-element ${contentInView2 ? 'showseventos-animate-in-right' : ''}`}
                >
                    <div className={`${theme}-showseventos-container`}>
                        <h3 className={`${theme}-showseventos-container-titulo`}>KARAOKE</h3>
                        <h3 className={`${theme}-showseventos-container-subtitulo`}>TODOS LOS LUNES A LAS 22.00 HS</h3>
                    </div>
                    <div className={`${theme}-showseventos-container`}>
                        <h3 className={`${theme}-showseventos-container-titulo`}>SHOW DE LA SEMANA</h3>
                        <h3 className={`${theme}-showseventos-container-subtitulo`}>TODOS LOS JUEVES A LAS 22.00 HS</h3>
                    </div>
                    <div className={`${theme}-showseventos-container`}>
                        <h3 className={`${theme}-showseventos-container-titulo`}>MÚSICA + KARAOKE</h3>
                        <h3 className={`${theme}-showseventos-container-subtitulo`}>VIERNES BIEN ARRIBA! DESDE LAS 23.30 HS</h3>
                    </div>
                </div>

                <p
                    className={`m-0 pb-4 text-center`}
                >
                    Entrada gratuita | Capacidad limitada | Consumición mínima
                </p>
            </div>
        </div>
    );
};

export default ShowsEventos;
